import type { ReactNode } from 'react';
import { useTranslation } from '@/shared/web/i18n/LanguageProvider';
import { LanguageSelector } from './app/LanguageSelector';

type AuthLayoutProps = {
  audience: 'creator' | 'employee';
  children: ReactNode;
};

export function AuthLayout({ audience, children }: AuthLayoutProps) {
  const { t } = useTranslation();
  const isCreator = audience === 'creator';

  return (
    <main className="bg-background grid min-h-screen lg:grid-cols-[minmax(0,1.05fr)_minmax(28rem,0.95fr)]">
      <div className="relative isolate flex min-h-52 flex-col justify-end overflow-hidden bg-[#101019] px-7 py-7 sm:min-h-64 sm:px-10 lg:min-h-screen lg:px-12 lg:py-14 xl:px-20">
        <img
          src={isCreator ? '/auth/creator.jpg' : '/auth/employee.jpg'}
          alt=""
          className="absolute inset-0 -z-20 size-full object-cover"
        />
        <div className="absolute inset-0 -z-10 bg-gradient-to-t from-black/75 via-black/10 to-black/10" />
        <div className="max-w-xl text-white">
          <p className="mb-3 text-[11px] font-semibold tracking-[0.24em] text-white/80 uppercase sm:mb-5">
            A2.Agency / {t(isCreator ? 'Creator portal' : 'Team access')}
          </p>
          <p className="text-4xl font-semibold leading-[0.95] tracking-[-0.055em] sm:text-5xl lg:text-[clamp(4rem,6vw,7rem)]">
            {t(isCreator ? 'Creator' : 'Employee')}<br />{t('Dashboard')}
          </p>
        </div>
      </div>

      <div className="flex min-w-0 items-center justify-center px-6 py-12 sm:px-10 lg:px-12 lg:py-16">
        <div className="flex w-full max-w-md flex-col gap-7">
          <div className="w-44 self-end"><LanguageSelector /></div>
          {children}
        </div>
      </div>
    </main>
  );
}
